//========================================================================================
/*

  goal          [obj]
  cellType      [str]
  translateKey  [str]
 
 */
//========================================================================================


import React from 'react';
import { translate } from 'react-i18next';

const HeaderCell = (props) => {
  const { goal, cellType, translateKey, t } = props;
  const cellData = Array.isArray(goal.logs) && goal.logs.find(log => log.type === cellType);
  return cellData ?
    <th>{t(translateKey)}</th>
    : null;
};

export default translate()(HeaderCell);